import React from 'react'

const Delete = (props) => (
    <svg width="10" height="12" viewBox="0 0 10 12" fill={props ? props.color : '#EB5757'}
         xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M3.77264 0.272705C3.43374 0.272705 3.159 0.529122 3.159 0.845428V1.41815H0.704457C0.365555 1.41815 0.0908203 1.67457 0.0908203 1.99087C0.0908203 2.30718 0.365555 2.5636 0.704457 2.5636H9.29537C9.63427 2.5636 9.909 2.30718 9.909 1.99087C9.909 1.67457 9.63427 1.41815 9.29537 1.41815H6.84082V0.845428C6.84082 0.529122 6.56609 0.272705 6.22718 0.272705H3.77264ZM8.06836 3.7094C8.40726 3.7094 8.682 3.96582 8.682 4.28212V10.0094C8.682 10.9583 7.85779 11.7275 6.84109 11.7275H3.15927C2.14256 11.7275 1.31836 10.9583 1.31836 10.0094V4.28212C1.31836 3.96582 1.59309 3.7094 1.932 3.7094H8.06836ZM2.54492 4.85508H7.45401V10.0096C7.45401 10.3259 7.17928 10.5823 6.84038 10.5823H3.15856C2.81966 10.5823 2.54492 10.3259 2.54492 10.0096V4.85508Z"
              />
    </svg>
)

export default Delete
